export function getN19ImportTable ()
{
    return [ 
    [0x0024,0xA4,0x00,0x00,0xFF],
	[0x0024,0x24,0x00,0xFF,0xFF],

	[0x0060,0x60,0x00,0x00,0xFF],
	[0x0060,0x60,0x00,0x03,0xFF],

	
	
	[0x0020,0x20,0x00,0xFF,0xFF],
	[0x0021,0x21,0x00,0xFF,0xFF],
	[0x0022,0x22,0x00,0xFF,0xFF],
	[0x0023,0x23,0x00,0xFF,0xFF],
	[0x00A4,0x24,0x00,0x00,0xFF],
	[0x0025,0x25,0x00,0xFF,0xFF],
	[0x0026,0x26,0x00,0xFF,0xFF],
	[0x0027,0x27,0x00,0xFF,0xFF],
	[0x2019,0x27,0x00,0xFF,0xFF],
	[0x0028,0x28,0x00,0xFF,0xFF],
	[0x0029,0x29,0x00,0xFF,0xFF],
	[0x002A,0x2A,0x00,0xFF,0xFF],
	[0x002B,0x2B,0x00,0xFF,0xFF],
	[0x002C,0x2C,0x00,0xFF,0xFF],
	[0x002D,0x2D,0x00,0xFF,0xFF],
	[0x002E,0x2E,0x00,0xFF,0xFF],
	[0x002F,0x2F,0x00,0xFF,0xFF],

	[0x0030,0x30,0x00,0xFF,0xFF],
	[0x0031,0x31,0x00,0xFF,0xFF],
	[0x0032,0x32,0x00,0xFF,0xFF],
	[0x0033,0x33,0x00,0xFF,0xFF],
	[0x0034,0x34,0x00,0xFF,0xFF],
	[0x0035,0x35,0x00,0xFF,0xFF],
	[0x0036,0x36,0x00,0xFF,0xFF],
	[0x0037,0x37,0x00,0xFF,0xFF],
	[0x0038,0x38,0x00,0xFF,0xFF],
	[0x0039,0x39,0x00,0xFF,0xFF],
	[0x003A,0x3A,0x00,0xFF,0xFF],
	[0x003B,0x3B,0x00,0xFF,0xFF],
	[0x003C,0x3C,0x00,0xFF,0xFF],
	[0x003D,0x3D,0x00,0xFF,0xFF],
	[0x003E,0x3E,0x00,0xFF,0xFF],
	[0x003F,0x3F,0x00,0xFF,0xFF],


	[0x0040,0x40,0x00,0xFF,0xFF],
	[0x0041,0x41,0x00,0xFF,0xFF],
	[0x0042,0x42,0x00,0xFF,0xFF],
	[0x0043,0x43,0x00,0xFF,0xFF],
	[0x0044,0x44,0x00,0xFF,0xFF],
	[0x0045,0x45,0x00,0xFF,0xFF],
	[0x0046,0x46,0x00,0xFF,0xFF],
	[0x0047,0x47,0x00,0xFF,0xFF],
	[0x0048,0x48,0x00,0xFF,0xFF],
	[0x0049,0x49,0x00,0xFF,0xFF],
	[0x004A,0x4A,0x00,0xFF,0xFF],
	[0x004B,0x4B,0x00,0xFF,0xFF],
	[0x004C,0x4C,0x00,0xFF,0xFF],
	[0x004D,0x4D,0x00,0xFF,0xFF],
	[0x004E,0x4E,0x00,0xFF,0xFF],
	[0x004F,0x4F,0x00,0xFF,0xFF],


	[0x0050,0x50,0x00,0xFF,0xFF],
	[0x0051,0x51,0x00,0xFF,0xFF],
	[0x0052,0x52,0x00,0xFF,0xFF],
	[0x0053,0x53,0x00,0xFF,0xFF],
	[0x0054,0x54,0x00,0xFF,0xFF],
	[0x0055,0x55,0x00,0xFF,0xFF],
	[0x0056,0x56,0x00,0xFF,0xFF],
	[0x0057,0x57,0x00,0xFF,0xFF],
	[0x0058,0x58,0x00,0xFF,0xFF],
	[0x0059,0x59,0x00,0xFF,0xFF],
	[0x005A,0x5A,0x00,0xFF,0xFF],
	[0x005B,0x5B,0x00,0xFF,0xFF],
	[0x005C,0x5C,0x00,0xFF,0xFF],
	[0x005D,0x5D,0x00,0xFF,0xFF],
	[0x005E,0x5E,0x00,0xFF,0xFF],
	[0x005F,0x5F,0x00,0xFF,0xFF],


	[0x0060,0x60,0x00,0x00,0xFF],
	[0x0060,0x60,0x00,0x03,0xFF],

	[0x0061,0x61,0x00,0xFF,0xFF],
	[0x0062,0x62,0x00,0xFF,0xFF],
	[0x0063,0x63,0x00,0xFF,0xFF],
	[0x0064,0x64,0x00,0xFF,0xFF],
	[0x0065,0x65,0x00,0xFF,0xFF],
	[0x0066,0x66,0x00,0xFF,0xFF],
	[0x0067,0x67,0x00,0xFF,0xFF],
	[0x0068,0x68,0x00,0xFF,0xFF],
	[0x0069,0x69,0x00,0xFF,0xFF],
	[0x006A,0x6A,0x00,0xFF,0xFF],
	[0x006B,0x6B,0x00,0xFF,0xFF],
	[0x006C,0x6C,0x00,0xFF,0xFF],
	[0x006D,0x6D,0x00,0xFF,0xFF],
	[0x006E,0x6E,0x00,0xFF,0xFF],
	[0x006F,0x6F,0x00,0xFF,0xFF],


	[0x0070,0x70,0x00,0xFF,0xFF],
	[0x0071,0x71,0x00,0xFF,0xFF],
	[0x0072,0x72,0x00,0xFF,0xFF],
	[0x0073,0x73,0x00,0xFF,0xFF],
	[0x0074,0x74,0x00,0xFF,0xFF],
	[0x0075,0x75,0x00,0xFF,0xFF],
	[0x0076,0x76,0x00,0xFF,0xFF],
	[0x0077,0x77,0x00,0xFF,0xFF],
	[0x0078,0x78,0x00,0xFF,0xFF],
	[0x0079,0x79,0x00,0xFF,0xFF],
	[0x007A,0x7A,0x00,0xFF,0xFF],
	[0x007B,0x7B,0x00,0xFF,0xFF],

	[0x007C,0x7C,0x00,0x00,0xFF],
	[0x007C,0x7C,0x00,0x03,0xFF],
	[0x007C,0x7C,0x00,0x04,0xFF],

	
	[0x00A6,0x7C,0x00,0x02,0xFF],
	[0x00A6,0x7C,0x00,0x01,0xFF],



	[0x007D,0x7D,0x00,0xFF,0xFF],
	[0x007E,0x7E,0x00,0xFF,0xFF],
	[0x007F,0x7F,0x00,0xFF,0xFF],




	// partie droite table 00  Alphabet latin


	[0x00A0,0xA0,0x00,0x00,0xFF],	// NBSP
	[0x00A1,0xA1,0x00,0x00,0xFF],
	[0x00A2,0xA2,0x00,0x00,0xFF],
	[0x00A3,0xA3,0x00,0x00,0xFF],
	[0x0024,0xA4,0x00,0x00,0xFF],
	[0x00A5,0xA5,0x00,0x00,0xFF],
	[0x00A7,0xA7,0x00,0x00,0xFF],
	[0x0300,0xA9,0x00,0x00,0xFF],
	[0x20AC,0xAA,0x00,0x00,0xFF],
	[0x00AB,0xAB,0x00,0x00,0xFF],
	[0x2190,0xAC,0x00,0x00,0xFF],
	[0x2191,0xAD,0x00,0x00,0xFF],
	[0x2192,0xAE,0x00,0x00,0xFF],
	[0x2193,0xAF,0x00,0x00,0xFF],



	[0x00B0,0xB0,0x00,0x00,0xFF],	// NBSP
	[0x00B1,0xB1,0x00,0x00,0xFF],
	[0x00B2,0xB2,0x00,0x00,0xFF],
	[0x00B3,0xB3,0x00,0x00,0xFF],
	[0x00D7,0xB4,0x00,0x00,0xFF],
	[0x00B5,0xB5,0x00,0x00,0xFF],
	[0x00B6,0xB6,0x00,0x00,0xFF],
	[0x00B7,0xB7,0x00,0x00,0xFF],
	[0x00F7,0xB8,0x00,0x00,0xFF],
//	[0x0301,0xB9,0x00,0x00,0xFF],
	[0x00B4,0xB9,0x00,0x00,0xFF],
	[0x201D,0xBA,0x00,0x00,0xFF],
	[0x00BB,0xBB,0x00,0x00,0xFF],
	[0x00BC,0xBC,0x00,0x00,0xFF],
	[0x00BD,0xBD,0x00,0x00,0xFF],
	[0x00BE,0xBE,0x00,0x00,0xFF],
	[0x00BF,0xBF,0x00,0x00,0xFF],



	// on attaque les lettres accentués

	

	[0x00C0,0xC1,'A',0x00,0xFF],	// accent grave
	[0x00C8,0xC1,'E',0x00,0xFF],
	[0x00CC,0xC1,'I',0x00,0xFF],
	[0x00D2,0xC1,'O',0x00,0xFF],
	[0x00D9,0xC1,'U',0x00,0xFF],
	[0x00E0,0xC1,'a',0x00,0xFF],
	[0x00E8,0xC1,'e',0x00,0xFF],
	[0x00EC,0xC1,'i',0x00,0xFF],
	[0x00F2,0xC1,'o',0x00,0xFF],
	[0x00F9,0xC1,'u',0x00,0xFF],
	[0x0123,0xC1,'g',0x00,0xFF],
	[0x1EF2,0xC1,'Y',0x00,0xFF],
	[0x1EF3,0xC1,'y',0x00,0xFF],



	[0x00B4,0xC2,' ',0x00,0xFF],
	[0x0139,0xC2,'L',0x00,0xFF],
	[0x013A,0xC2,'l',0x00,0xFF],
	[0x00C1,0xC2,'A',0x00,0xFF],	// accent grave
	[0x00C9,0xC2,'E',0x00,0xFF],
	[0x00CD,0xC2,'I',0x00,0xFF],
	[0x00D3,0xC2,'O',0x00,0xFF],
	[0x00DA,0xC2,'U',0x00,0xFF],
	[0x00E1,0xC2,'a',0x00,0xFF],
	[0x00E9,0xC2,'e',0x00,0xFF],
	[0x00ED,0xC2,'i',0x00,0xFF],
	[0x00F3,0xC2,'o',0x00,0xFF],
	[0x00FA,0xC2,'u',0x00,0xFF],
	[0x00DD,0xC2,'Y',0x00,0xFF],
	[0x00FD,0xC2,'y',0x00,0xFF],
	[0x0106,0xC2,'C',0x00,0xFF],	// accent grave
	[0x0107,0xC2,'c',0x00,0xFF],
	[0x0143,0xC2,'N',0x00,0xFF],
	[0x0144,0xC2,'n',0x00,0xFF],
	[0x0154,0xC2,'R',0x00,0xFF],
	[0x01FE,0xC2,0xE9,0x00,0xFF],
	[0x01FF,0xC2,0xF9,0x00,0xFF],
	[0x0155,0xC2,'r',0x00,0xFF],
	[0x015A,0xC2,'S',0x00,0xFF],
	[0x015B,0xC2,'s',0x00,0xFF],
	[0x0179,0xC2,'Z',0x00,0xFF],
	[0x017A,0xC2,'z',0x00,0xFF],
	[0x01FC,0xC2,0xE1,0x00,0xFF],
	[0x01FD,0xC2,0xF1,0x00,0xFF],



	[0x02C6,0xC3,' ',0x00,0xFF],	// 
	[0x00C2,0xC3,'A',0x00,0xFF],	// accent circonflexe
	[0x00CA,0xC3,'E',0x00,0xFF],
	[0x00CE,0xC3,'I',0x00,0xFF],
	[0x00D4,0xC3,'O',0x00,0xFF],
	[0x00DB,0xC3,'U',0x00,0xFF],
	[0x00E2,0xC3,'a',0x00,0xFF],
	[0x00EA,0xC3,'e',0x00,0xFF],
	[0x00EE,0xC3,'i',0x00,0xFF],
	[0x00F4,0xC3,'o',0x00,0xFF],
	[0x00FB,0xC3,'u',0x00,0xFF],
	[0x0108,0xC3,'C',0x00,0xFF],
	[0x0109,0xC3,'c',0x00,0xFF],
	[0x011C,0xC3,'G',0x00,0xFF],	// accent grave
	[0x011D,0xC3,'g',0x00,0xFF],
	[0x0124,0xC3,'H',0x00,0xFF],
	[0x0125,0xC3,'h',0x00,0xFF],
	[0x0134,0xC3,'J',0x00,0xFF],
	[0x0135,0xC3,'j',0x00,0xFF],	// accent grave
	[0x015C,0xC3,'S',0x00,0xFF],
	[0x015D,0xC3,'s',0x00,0xFF],
	[0x0174,0xC3,'W',0x00,0xFF],
	[0x0175,0xC3,'w',0x00,0xFF],
	[0x0176,0xC3,'Y',0x00,0xFF],
	[0x0177,0xC3,'y',0x00,0xFF],



	[0x02DC,0xC4,' ',0x00,0xFF],
	[0x00C3,0xC4,'A',0x00,0xFF],	// accent tilde
	[0x0128,0xC4,'I',0x00,0xFF],
	[0x00D5,0xC4,'O',0x00,0xFF],
	[0x0168,0xC4,'U',0x00,0xFF],
	[0x00E3,0xC4,'a',0x00,0xFF],
	[0x0129,0xC4,'i',0x00,0xFF],
	[0x00F5,0xC4,'o',0x00,0xFF],
	[0x0169,0xC4,'u',0x00,0xFF],
	[0x00F1,0xC4,'n',0x00,0xFF],
	[0x00D1,0xC4,'N',0x00,0xFF],

	[0x02C9,0xC5,' ',0x00,0xFF],
	[0x0100,0xC5,'A',0x00,0xFF],
	[0x0101,0xC5,'a',0x00,0xFF],
	[0x0112,0xC5,'E',0x00,0xFF],
	[0x0113,0xC5,'e',0x00,0xFF],
	[0x012A,0xC5,'I',0x00,0xFF],
	[0x012B,0xC5,'i',0x00,0xFF],
	[0x014C,0xC5,'O',0x00,0xFF],
	[0x014D,0xC5,'o',0x00,0xFF],
	[0x016A,0xC5,'U',0x00,0xFF],
	[0x016B,0xC5,'u',0x00,0xFF],

	[0x02D8,0xC6,' ',0x00,0xFF],
	[0x0102,0xC6,'A',0x00,0xFF],
	[0x0103,0xC6,'a',0x00,0xFF],
	[0x0114,0xC6,'E',0x00,0xFF],
	[0x0115,0xC6,'e',0x00,0xFF],
	[0x011E,0xC6,'G',0x00,0xFF],
	[0x011F,0xC6,'g',0x00,0xFF],
	[0x012C,0xC6,'I',0x00,0xFF],
	[0x012D,0xC6,'i',0x00,0xFF],
	[0x014E,0xC6,'O',0x00,0xFF],
	[0x014F,0xC6,'o',0x00,0xFF],
	[0x016C,0xC6,'U',0x00,0xFF],
	[0x016D,0xC6,'u',0x00,0xFF],

	[0x02D9,0xC7,' ',0x00,0xFF],
	[0x010A,0xC7,'C',0x00,0xFF],
	[0x010B,0xC7,'c',0x00,0xFF],
	[0x0116,0xC7,'E',0x00,0xFF],
	[0x0117,0xC7,'e',0x00,0xFF],
	[0x0120,0xC7,'G',0x00,0xFF],
	[0x0121,0xC7,'g',0x00,0xFF],
	[0x017B,0xC7,'Z',0x00,0xFF],
	[0x017C,0xC7,'z',0x00,0xFF],


	[0x00A8,0xC8,' ',0x00,0xFF],
	[0x00C4,0xC8,'A',0x00,0xFF],
	[0x00CB,0xC8,'E',0x00,0xFF],
	[0x00CF,0xC8,'I',0x00,0xFF],
	[0x00D6,0xC8,'O',0x00,0xFF],
	[0x00DC,0xC8,'U',0x00,0xFF],
	[0x00E4,0xC8,'a',0x00,0xFF],
	[0x00EB,0xC8,'e',0x00,0xFF],
	[0x00EF,0xC8,'i',0x00,0xFF],
	[0x00F6,0xC8,'o',0x00,0xFF],
	[0x00FC,0xC8,'u',0x00,0xFF],
	[0x00FF,0xC8,'y',0x00,0xFF],
	[0x0178,0xC8,'Y',0x00,0xFF],


	[0x00BA,0xB0,0x00,0x00,0xFF],
	[0x00C5,0xCA,'A',0x00,0xFF],
	[0x00E5,0xCA,'a',0x00,0xFF],
	[0x016F,0xCA,'u',0x00,0xFF],
	[0x016E,0xCA,'U',0x00,0xFF],

	[0x02DA,0xC9,' ',0x00,0xFF],

	[0x00B8,0xCB,' ',0x00,0xFF],
	[0x00C7,0xCB,'C',0x00,0xFF],
	[0x00E7,0xCB,'c',0x00,0xFF],
	[0x0122,0xCB,'G',0x00,0xFF],
	[0x0123,0xCB,'g',0x00,0xFF],
	[0x0136,0xCB,'K',0x00,0xFF],
	[0x0137,0xCB,'k',0x00,0xFF],
	[0x013B,0xCB,'L',0x00,0xFF],
	[0x013C,0xCB,'l',0x00,0xFF],
	[0x0145,0xCB,'N',0x00,0xFF],
	[0x0146,0xCB,'n',0x00,0xFF],
	[0x0156,0xCB,'R',0x00,0xFF],
	[0x0157,0xCB,'r',0x00,0xFF],
	[0x015E,0xCB,'S',0x00,0xFF],
	[0x015F,0xCB,'s',0x00,0xFF],
	[0x0162,0xCB,'T',0x00,0xFF],
	[0x0163,0xCB,'t',0x00,0xFF],

	[0x02DD,0xCD,' ',0x00,0xFF],
	[0x0150,0xCD,'O',0x00,0xFF],
	[0x0151,0xCD,'o',0x00,0xFF],
	[0x0170,0xCD,'U',0x00,0xFF],
	[0x0171,0xCD,'u',0x00,0xFF],

	[0x02DB,0xCE,' ',0x00,0xFF],
	[0x0104,0xCE,'A',0x00,0xFF],
	[0x0105,0xCE,'a',0x00,0xFF],
	[0x0118,0xCE,'E',0x00,0xFF],
	[0x0119,0xCE,'e',0x00,0xFF],
	[0x012E,0xCE,'I',0x00,0xFF],
	[0x012F,0xCE,'i',0x00,0xFF],
	[0x0172,0xCE,'U',0x00,0xFF],
	[0x0173,0xCE,'u',0x00,0xFF],
	

	[0x010C,0xCF,'C',0x00,0xFF],
	[0x010D,0xCF,'c',0x00,0xFF],
	[0x010E,0xCF,'D',0x00,0xFF],
	[0x010F,0xCF,'d',0x00,0xFF],
	[0x011A,0xCF,'E',0x00,0xFF],
	[0x011B,0xCF,'e',0x00,0xFF],
	[0x013D,0xCF,'L',0x00,0xFF],
	[0x013C,0xCF,'l',0x00,0xFF],
	[0x0147,0xCF,'N',0x00,0xFF],
	[0x0148,0xCF,'n',0x00,0xFF],
	[0x0158,0xCF,'R',0x00,0xFF],
	[0x0159,0xCF,'r',0x00,0xFF],
	[0x0160,0xCF,'S',0x00,0xFF],
	[0x0161,0xCF,'s',0x00,0xFF],
	[0x0164,0xCF,'T',0x00,0xFF],
	[0x0165,0xCF,'t',0x00,0xFF],
	[0x017D,0xCF,'Z',0x00,0xFF],
	[0x017E,0xCF,'z',0x00,0xFF],
	[0x01CD,0xCF,'A',0x00,0xFF],
	[0x01CE,0xCF,'a',0x00,0xFF],
	[0x01CF,0xCF,'I',0x00,0xFF],
	[0x01D0,0xCF,'i',0x00,0xFF],
	[0x01D1,0xCF,'O',0x00,0xFF],
	[0x01D2,0xCF,'o',0x00,0xFF],
	[0x01D3,0xCF,'U',0x00,0xFF],
	[0x01D4,0xCF,'u',0x00,0xFF],

	[0x00AF,0xD0,0x00,0x00,0xFF],
	[0x00B9,0xD1,0x00,0x00,0xFF],
	[0x00AE,0xD2,0x00,0x00,0xFF],
	[0x00A9,0xD3,0x00,0x00,0xFF],
	[0x2122,0xD4,0x00,0x00,0xFF],
	[0x266A,0xD5,0x00,0x00,0xFF],
	[0x00AC,0xD6,0x00,0x00,0xFF],
	[0x00A6,0xD7,0x00,0x00,0xFF],

	[0x215B,0xDC,0x00,0x00,0xFF],
	[0x215C,0xDD,0x00,0x00,0xFF],
	[0x215D,0xDE,0x00,0x00,0xFF],
	[0x215E,0xDF,0x00,0x00,0xFF],



	[0x2126,0xE0,0x00,0x00,0xFF],
	[0x00C6,0xE1,0x00,0x00,0xFF],
	[0x0110,0xE2,0x00,0x00,0xFF],
	[0x1EA1,0xE3,0x00,0x00,0xFF],
	[0x00D0,0xE2,0x00,0x00,0xFF],
	[0x0126,0xE4,0x00,0x00,0xFF],
	
	[0x0132,0xE6,0x00,0x00,0xFF],
	[0x013F,0xE7,0x00,0x00,0xFF],
	[0x0141,0xE8,0x00,0x00,0xFF],
	[0x00D8,0xE9,0x00,0x00,0xFF],
	[0x0152,0xEA,0x00,0x00,0xFF],
	[0x1ECD,0xEB,0x00,0x00,0xFF],
	[0x00FE,0xEC,0x00,0x00,0xFF],
	[0x0166,0xED,0x00,0x00,0xFF],
	[0x014A,0xEE,0x00,0x00,0xFF],
	[0x0149,0xEF,0x00,0x00,0xFF],


	[0x0138,0xF0,0x00,0x00,0xFF],
	[0x00E6,0xF1,0x00,0x00,0xFF],
	[0x0111,0xF2,0x00,0x00,0xFF],
	[0x00F0,0xF3,0x00,0x00,0xFF],
	[0x0127,0xF4,0x00,0x00,0xFF],
	[0x00AC,0xF5,0x00,0x00,0xFF],
	[0x0133,0xF6,0x00,0x00,0xFF],
	[0x0140,0xF7,0x00,0x00,0xFF],
	[0x0142,0xF8,0x00,0x00,0xFF],
	[0x00F8,0xF9,0x00,0x00,0xFF],
	[0x0153,0xFA,0x00,0x00,0xFF],
	[0x00DF,0xFB,0x00,0x00,0xFF],
	[0x00DE,0xFC,0x00,0x00,0xFF],
	[0x0167,0xFD,0x00,0x00,0xFF],
	[0x014B,0xFE,0x00,0x00,0xFF],
	[0x0020,0xFF,0x00,0x00,0xFF],

	
	// Table de code n° 01 / Cyrrilique


	// exception sur la table 01 ruthenian language
	[0x0490,0xA5,0x00,0x01,0x55],
	[0x0491,0xF5,0x00,0x01,0x55],


	[0x0020,0xA0,0x00,0x01,0xFF],
	[0x0401,0xA1,0x00,0x01,0xFF],
	[0x0402,0xA2,0x00,0x01,0xFF],
	[0x0403,0xA3,0x00,0x01,0xFF],
	[0x0404,0xA4,0x00,0x01,0xFF],
	[0x0405,0xA5,0x00,0x01,0xFF],
	[0x0406,0xA6,0x00,0x01,0xFF],
	[0x0407,0xA7,0x00,0x01,0xFF],
	[0x0408,0xA8,0x00,0x01,0xFF],
	[0x0409,0xA9,0x00,0x01,0xFF],
	[0x040A,0xAA,0x00,0x01,0xFF],
	[0x040B,0xAB,0x00,0x01,0xFF],
	[0x040C,0xAC,0x00,0x01,0xFF],
	[0x0020,0xAD,0x00,0x01,0xFF],
	[0x040E,0xAE,0x00,0x01,0xFF],
	[0x040F,0xAF,0x00,0x01,0xFF],



	[0x0410,0xB0,0x00,0x01,0xFF],
	[0x0411,0xB1,0x00,0x01,0xFF],
	[0x0412,0xB2,0x00,0x01,0xFF],
	[0x0413,0xB3,0x00,0x01,0xFF],
	[0x0414,0xB4,0x00,0x01,0xFF],
	[0x0415,0xB5,0x00,0x01,0xFF],
	[0x0416,0xB6,0x00,0x01,0xFF],
	[0x0417,0xB7,0x00,0x01,0xFF],
	[0x0418,0xB8,0x00,0x01,0xFF],
	[0x0419,0xB9,0x00,0x01,0xFF],
	[0x041A,0xBA,0x00,0x01,0xFF],
	[0x041B,0xBB,0x00,0x01,0xFF],
	[0x041C,0xBC,0x00,0x01,0xFF],
	[0x041D,0xBD,0x00,0x01,0xFF],
	[0x041E,0xBE,0x00,0x01,0xFF],
	[0x041F,0xBF,0x00,0x01,0xFF],


	[0x0420,0xC0,0x00,0x01,0xFF],
	[0x0421,0xC1,0x00,0x01,0xFF],
	[0x0422,0xC2,0x00,0x01,0xFF],
	[0x0423,0xC3,0x00,0x01,0xFF],
	[0x0424,0xC4,0x00,0x01,0xFF],
	[0x0425,0xC5,0x00,0x01,0xFF],
	[0x0426,0xC6,0x00,0x01,0xFF],
	[0x0427,0xC7,0x00,0x01,0xFF],
	[0x0428,0xC8,0x00,0x01,0xFF],
	[0x0429,0xC9,0x00,0x01,0xFF],
	[0x042A,0xCA,0x00,0x01,0xFF],
	[0x042B,0xCB,0x00,0x01,0xFF],
	[0x042C,0xCC,0x00,0x01,0xFF],
	[0x042D,0xCD,0x00,0x01,0xFF],
	[0x042E,0xCE,0x00,0x01,0xFF],
	[0x042F,0xCF,0x00,0x01,0xFF],


	[0x0430,0xD0,0x00,0x01,0xFF],
	[0x0431,0xD1,0x00,0x01,0xFF],
	[0x0432,0xD2,0x00,0x01,0xFF],
	[0x0433,0xD3,0x00,0x01,0xFF],
	[0x0434,0xD4,0x00,0x01,0xFF],
	[0x0435,0xD5,0x00,0x01,0xFF],
	[0x0436,0xD6,0x00,0x01,0xFF],
	[0x0437,0xD7,0x00,0x01,0xFF],
	[0x0438,0xD8,0x00,0x01,0xFF],
	[0x0439,0xD9,0x00,0x01,0xFF],
	[0x043A,0xDA,0x00,0x01,0xFF],
	[0x043B,0xDB,0x00,0x01,0xFF],
	[0x043C,0xDC,0x00,0x01,0xFF],
	[0x043D,0xDD,0x00,0x01,0xFF],
	[0x043E,0xDE,0x00,0x01,0xFF],
	[0x043F,0xDF,0x00,0x01,0xFF],


	[0x0440,0xE0,0x00,0x01,0xFF],
	[0x0441,0xE1,0x00,0x01,0xFF],
	[0x0442,0xE2,0x00,0x01,0xFF],
	[0x0443,0xE3,0x00,0x01,0xFF],
	[0x0444,0xE4,0x00,0x01,0xFF],
	[0x0445,0xE5,0x00,0x01,0xFF],
	[0x0446,0xE6,0x00,0x01,0xFF],
	[0x0447,0xE7,0x00,0x01,0xFF],
	[0x0448,0xE8,0x00,0x01,0xFF],
	[0x0449,0xE9,0x00,0x01,0xFF],
	[0x044A,0xEA,0x00,0x01,0xFF],
	[0x044B,0xEB,0x00,0x01,0xFF],
	[0x044C,0xEC,0x00,0x01,0xFF],
	[0x044D,0xED,0x00,0x01,0xFF],
	[0x044E,0xEE,0x00,0x01,0xFF],
	[0x044F,0xEF,0x00,0x01,0xFF],


	[0x2116,0xF0,0x00,0x01,0xFF],
	[0x0451,0xF1,0x00,0x01,0xFF],
	[0x0452,0xF2,0x00,0x01,0xFF],
	[0x0453,0xF3,0x00,0x01,0xFF],
	[0x0454,0xF4,0x00,0x01,0xFF],
	[0x0455,0xF5,0x00,0x01,0xFF],
	[0x0456,0xF6,0x00,0x01,0xFF],
	[0x0457,0xF7,0x00,0x01,0xFF],
	[0x0458,0xF8,0x00,0x01,0xFF],
	[0x0459,0xF9,0x00,0x01,0xFF],
	[0x045A,0xFA,0x00,0x01,0xFF],
	[0x045B,0xFB,0x00,0x01,0xFF],
	[0x045C,0xFC,0x00,0x01,0xFF],
	[0x00A7,0xFD,0x00,0x01,0xFF],
	[0x045E,0xFE,0x00,0x01,0xFF],
	[0x045F,0xFF,0x00,0x01,0xFF],


	// table 2 Latin / Arable


	[0x0020,0x20,0x00,0x02,0xFF],
	[0x00A0,0xA0,0x00,0x02,0xFF],
	[0x00A4,0xA4,0x00,0x02,0xFF],
	[0x060C,0xAC,0x00,0x02,0xFF],
	[0x061F,0xBF,0x00,0x02,0xFF],
	[0x061B,0xBB,0x00,0x02,0xFF],


	[0x0660,0x30,0x00,0x02,0xFF],
	[0x0661,0x31,0x00,0x02,0xFF],
	[0x0662,0x32,0x00,0x02,0xFF],
	[0x0663,0x33,0x00,0x02,0xFF],
	[0x0664,0x34,0x00,0x02,0xFF],
	[0x0665,0x35,0x00,0x02,0xFF],
	[0x0666,0x36,0x00,0x02,0xFF],
	[0x0667,0x37,0x00,0x02,0xFF],
	[0x0668,0x38,0x00,0x02,0xFF],
	[0x0669,0x39,0x00,0x02,0xFF],



	[0x0621,0xC1,0x00,0x02,0xFF],
	[0x0622,0xC2,0x00,0x02,0xFF],
	[0x0623,0xC3,0x00,0x02,0xFF],
	[0x0624,0xC4,0x00,0x02,0xFF],
	[0x0625,0xC5,0x00,0x02,0xFF],
	[0x0626,0xC6,0x00,0x02,0xFF],
	[0x0627,0xC7,0x00,0x02,0xFF],
	[0x0628,0xC8,0x00,0x02,0xFF],
	[0x0629,0xC9,0x00,0x02,0xFF],
	[0x062A,0xCA,0x00,0x02,0xFF],
	[0x062B,0xCB,0x00,0x02,0xFF],
	[0x062C,0xCC,0x00,0x02,0xFF],
	[0x062D,0xCD,0x00,0x02,0xFF],
	[0x062E,0xCE,0x00,0x02,0xFF],
	[0x062F,0xCF,0x00,0x02,0xFF],

	[0x0630,0xD0,0x00,0x02,0xFF],
	[0x0631,0xD1,0x00,0x02,0xFF],
	[0x0632,0xD2,0x00,0x02,0xFF],
	[0x0633,0xD3,0x00,0x02,0xFF],
	[0x0634,0xD4,0x00,0x02,0xFF],
	[0x0635,0xD5,0x00,0x02,0xFF],
	[0x0636,0xD6,0x00,0x02,0xFF],
	[0x0637,0xD7,0x00,0x02,0xFF],
	[0x0638,0xD8,0x00,0x02,0xFF],
	[0x0639,0xD9,0x00,0x02,0xFF],
	[0x063A,0xDA,0x00,0x02,0xFF],
	[0x063B,0xDB,0x00,0x02,0xFF],
	[0x063C,0xDC,0x00,0x02,0xFF],
	[0x063D,0xDD,0x00,0x02,0xFF],
	[0x063E,0xDE,0x00,0x02,0xFF],
	[0x063F,0xDF,0x00,0x02,0xFF],


	[0x0640,0xE0,0x00,0x02,0xFF],
	[0x0641,0xE1,0x00,0x02,0xFF],
	[0x0642,0xE2,0x00,0x02,0xFF],
	[0x0643,0xE3,0x00,0x02,0xFF],
	[0x0644,0xE4,0x00,0x02,0xFF],
	[0x0645,0xE5,0x00,0x02,0xFF],
	[0x0646,0xE6,0x00,0x02,0xFF],
	[0x0647,0xE7,0x00,0x02,0xFF],
	[0x0648,0xE8,0x00,0x02,0xFF],
	[0x0649,0xE9,0x00,0x02,0xFF],
	[0x064A,0xEA,0x00,0x02,0xFF],
	[0x064B,0xEB,0x00,0x02,0xFF],
	[0x064C,0xEC,0x00,0x02,0xFF],
	[0x064D,0xED,0x00,0x02,0xFF],
	[0x064E,0xEE,0x00,0x02,0xFF],
	[0x064F,0xEF,0x00,0x02,0xFF],

	[0x0650,0xF0,0x00,0x02,0xFF],
	[0x0651,0xF1,0x00,0x02,0xFF],
	[0x0622,0xF2,0x00,0x02,0xFF],






	// table 3 Latin / Greek
	[0x0020,0x20,0x00,0x03,0xFF],

	[0x00A0,0xA0,0x00,0x03,0xFF],
	[0x00A3,0xA3,0x00,0x03,0xFF],
	[0x00B0,0xB0,0x00,0x03,0xFF],
	[0x00B1,0xB1,0x00,0x03,0xFF],
	[0x00B2,0xB2,0x00,0x03,0xFF],
	[0x00B3,0xB3,0x00,0x03,0xFF],
	[0x00AC,0xAC,0x00,0x03,0xFF],
	[0x00AF,0xAF,0x00,0x03,0xFF],

	[0x00BD,0xBD,0x00,0x03,0xFF],
	[0x00BB,0xBB,0x00,0x03,0xFF],
	[0x00AB,0xAB,0x00,0x03,0xFF],
	[0x00A9,0xA9,0x00,0x03,0xFF],
	[0x00A7,0xA7,0x00,0x03,0xFF],
	[0x00A6,0xA6,0x00,0x03,0xFF],

	[0x0385,0xB5,0x00,0x03,0xFF],
	[0x0384,0xB6,0x00,0x03,0xFF],

	[0x0386,0xB6,0x00,0x03,0xFF],
	[0x0387,0xB7,0x00,0x03,0xFF],
	[0x0388,0xB8,0x00,0x03,0xFF],
	[0x0389,0xB9,0x00,0x03,0xFF],
	[0x038A,0xBA,0x00,0x03,0xFF],
	
	[0x038C,0xBC,0x00,0x03,0xFF],
	
	[0x038E,0xBE,0x00,0x03,0xFF],
	[0x038F,0xBF,0x00,0x03,0xFF],

	[0x0390,0xC0,0x00,0x03,0xFF],
	[0x0391,0xC1,0x00,0x03,0xFF],
	[0x0392,0xC2,0x00,0x03,0xFF],
	[0x0393,0xC3,0x00,0x03,0xFF],
	[0x0394,0xC4,0x00,0x03,0xFF],
	[0x0395,0xC5,0x00,0x03,0xFF],
	[0x0396,0xC6,0x00,0x03,0xFF],
	[0x0397,0xC7,0x00,0x03,0xFF],
	[0x0398,0xC8,0x00,0x03,0xFF],
	[0x0399,0xC9,0x00,0x03,0xFF],
	[0x039A,0xCA,0x00,0x03,0xFF],
	[0x039B,0xCB,0x00,0x03,0xFF],
	[0x039C,0xCC,0x00,0x03,0xFF],
	[0x039D,0xCD,0x00,0x03,0xFF],
	[0x039E,0xCE,0x00,0x03,0xFF],
	[0x039F,0xCF,0x00,0x03,0xFF],


	[0x03A0,0xD0,0x00,0x03,0xFF],
	[0x03A1,0xD1,0x00,0x03,0xFF],
	[0x03A3,0xD3,0x00,0x03,0xFF],
	[0x03A4,0xD4,0x00,0x03,0xFF],
	[0x03A5,0xD5,0x00,0x03,0xFF],
	[0x03A6,0xD6,0x00,0x03,0xFF],
	[0x03A7,0xD7,0x00,0x03,0xFF],
	[0x03A8,0xD8,0x00,0x03,0xFF],
	[0x03A9,0xD9,0x00,0x03,0xFF],
	[0x03AA,0xDA,0x00,0x03,0xFF],
	[0x03AB,0xDB,0x00,0x03,0xFF],
	[0x03AC,0xDC,0x00,0x03,0xFF],
	[0x03AD,0xDD,0x00,0x03,0xFF],
	[0x03AE,0xDE,0x00,0x03,0xFF],
	[0x03AF,0xDF,0x00,0x03,0xFF],


	[0x03B0,0xE0,0x00,0x03,0xFF],
	[0x03B1,0xE1,0x00,0x03,0xFF],
	[0x03B2,0xE2,0x00,0x03,0xFF],
	[0x03B3,0xE3,0x00,0x03,0xFF],
	[0x03B4,0xE4,0x00,0x03,0xFF],
	[0x03B5,0xE5,0x00,0x03,0xFF],
	[0x03B6,0xE6,0x00,0x03,0xFF],
	[0x03B7,0xE7,0x00,0x03,0xFF],
	[0x03B8,0xE8,0x00,0x03,0xFF],
	[0x03B9,0xE9,0x00,0x03,0xFF],
	[0x03BA,0xEA,0x00,0x03,0xFF],
	[0x03BB,0xEB,0x00,0x03,0xFF],
	[0x03BC,0xEC,0x00,0x03,0xFF],
	[0x03BD,0xED,0x00,0x03,0xFF],
	[0x03BE,0xEE,0x00,0x03,0xFF],
	[0x03BF,0xEF,0x00,0x03,0xFF],


	[0x03C0,0xF0,0x00,0x03,0xFF],
	[0x03C1,0xF1,0x00,0x03,0xFF],
	[0x03C2,0xF2,0x00,0x03,0xFF],
	[0x03C3,0xF3,0x00,0x03,0xFF],
	[0x03C4,0xF4,0x00,0x03,0xFF],
	[0x03C5,0xF5,0x00,0x03,0xFF],
	[0x03C6,0xF6,0x00,0x03,0xFF],
	[0x03C7,0xF7,0x00,0x03,0xFF],
	[0x03C8,0xF8,0x00,0x03,0xFF],
	[0x03C9,0xF9,0x00,0x03,0xFF],
	[0x03CA,0xFA,0x00,0x03,0xFF],
	[0x03CB,0xFB,0x00,0x03,0xFF],
	[0x03CC,0xFC,0x00,0x03,0xFF],
	[0x03CD,0xFD,0x00,0x03,0xFF],
	[0x03CE,0xFE,0x00,0x03,0xFF],






	// tble 04 hebreu

	
	[0x00A0,0xAF,0x00,0x04,0xFF],
	[0x00AF,0xAF,0x00,0x04,0xFF],
	
	[0x00A2,0xA2,0x00,0x04,0xFF],
	[0x00A3,0xA3,0x00,0x04,0xFF],
	[0x00A4,0xA4,0x00,0x04,0xFF],
	[0x00A5,0xA5,0x00,0x04,0xFF],
	[0x00A6,0xA6,0x00,0x04,0xFF],
	[0x00A7,0xA7,0x00,0x04,0xFF],
	[0x00A8,0xA8,0x00,0x04,0xFF],
	[0x00A9,0xA9,0x00,0x04,0xFF],
	[0x00D7,0xAA,0x00,0x04,0xFF],
	[0x00AB,0xAB,0x00,0x04,0xFF],
	[0x00AC,0xAC,0x00,0x04,0xFF],
	[0x0020,0xAD,0x00,0x04,0xFF],
	[0x00AE,0xAE,0x00,0x04,0xFF],
	[0x00AF,0xAF,0x00,0x04,0xFF],



	[0x00B0,0xB0,0x00,0x04,0xFF],
	[0x00B1,0xB1,0x00,0x04,0xFF],
	[0x00B2,0xB2,0x00,0x04,0xFF],
	[0x00B3,0xB3,0x00,0x04,0xFF],
	[0x00B4,0xB4,0x00,0x04,0xFF],
	[0x00B5,0xB5,0x00,0x04,0xFF],
	[0x00B6,0xB6,0x00,0x04,0xFF],
	[0x00B7,0xB7,0x00,0x04,0xFF],
	[0x00B8,0xB8,0x00,0x04,0xFF],
	[0x00B9,0xB9,0x00,0x04,0xFF],
	[0x00F7,0xBA,0x00,0x04,0xFF],
	[0x00BB,0xBB,0x00,0x04,0xFF],
	[0x00BC,0xBC,0x00,0x04,0xFF],
	[0x00BD,0xBD,0x00,0x04,0xFF],
	[0x00BE,0xBE,0x00,0x04,0xFF],

	[0x05C3,0xDF,0x00,0x04,0xFF],

	[0x05D0,0xE0,0x00,0x04,0xFF],
	[0x05D1,0xE1,0x00,0x04,0xFF],
	[0x05D2,0xE2,0x00,0x04,0xFF],
	[0x05D3,0xE3,0x00,0x04,0xFF],
	[0x05D4,0xE4,0x00,0x04,0xFF],
	[0x05D5,0xE5,0x00,0x04,0xFF],
	[0x05D6,0xE6,0x00,0x04,0xFF],
	[0x05D7,0xE7,0x00,0x04,0xFF],
	[0x05D8,0xE8,0x00,0x04,0xFF],
	[0x05D9,0xE9,0x00,0x04,0xFF],
	[0x05DA,0xEA,0x00,0x04,0xFF],
	[0x05DB,0xEB,0x00,0x04,0xFF],
	[0x05DC,0xEC,0x00,0x04,0xFF],
	[0x05DD,0xED,0x00,0x04,0xFF],
	[0x05DE,0xEE,0x00,0x04,0xFF],
	[0x05DF,0xEF,0x00,0x04,0xFF],


	[0x05E0,0xF0,0x00,0x04,0xFF],
	[0x05E1,0xF1,0x00,0x04,0xFF],
	[0x05E2,0xF2,0x00,0x04,0xFF],
	[0x05E3,0xF3,0x00,0x04,0xFF],
	[0x05E4,0xF4,0x00,0x04,0xFF],
	[0x05E5,0xF5,0x00,0x04,0xFF],
	[0x05E6,0xF6,0x00,0x04,0xFF],
	[0x05E7,0xF7,0x00,0x04,0xFF],
	[0x05E8,0xF8,0x00,0x04,0xFF],
	[0x05E9,0xF9,0x00,0x04,0xFF],
	[0x05EA,0xFA,0x00,0x04,0xFF],
	[0x05EB,0xFB,0x00,0x04,0xFF],

	[0xFFFF,' ',0xFF,0xFF,0xFF]
    ]  
}